// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"048724ef","307":"fdf5dc99","453":"1f01e18b"}[chunkId] + ".chunk.js";
};